import { ApiResponse } from "types";
import { IUser } from "interfaces";
import { Apis, Enums } from "utils";

export interface IUserData {
  all(): Promise<ApiResponse<IUser[]>>;
  find(query: any, populated: boolean): Promise<ApiResponse<IUser>>;
  insert(payload: IUser[]): Promise<ApiResponse<IUser[]>>;
  update(payload: IUser): Promise<ApiResponse<IUser>>;
  addHiddenPotluck(id: string, potluckId: string): Promise<ApiResponse<IUser>>;
  removeHiddenPotluck(id: string, potluckId: string): Promise<ApiResponse<IUser>>;
}

export class UserData implements IUserData {
  private collection = "users";

  async all(): Promise<ApiResponse<IUser[]>> {
    try {
      const response = await Apis.current().get(`${this.collection}`);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IUser[]>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser[]>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IUser[]>;
    }
  }

  async find(query: any, populated: boolean): Promise<ApiResponse<IUser>> {
    try {
      const response = await Apis.current().post(`${this.collection}/find`, { ...query, populated: populated } as any);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
    }
  }

  async insert(payload: IUser[]): Promise<ApiResponse<IUser[]>> {
    try {
      const response = await Apis.current().post(`${this.collection}/bulk`, payload);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IUser[]>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser[]>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: [] } as ApiResponse<IUser[]>;
    }
  }

  async update(payload: IUser): Promise<ApiResponse<IUser>> {
    try {
      const response = await Apis.current().put(`${this.collection}`, payload);
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
    }
  }

  async addHiddenPotluck(id: string, potluckId: string): Promise<ApiResponse<IUser>> {
    try {
      const response = await Apis.current().put(`${this.collection}/settings/add-hidden-potluck`, { id, potluckId });
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
    }
  }

  async removeHiddenPotluck(id: string, potluckId: string): Promise<ApiResponse<IUser>> {
    try {
      const response = await Apis.current().put(`${this.collection}/settings/remove-hidden-potluck`, { id, potluckId });
      if (response.data.err) {
        return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
      } else {
        return { status: Enums.EnumResponse.Success, payload: response.data } as ApiResponse<IUser>;
      }
    } catch (err) {
      return { status: Enums.EnumResponse.Error, payload: null } as ApiResponse<IUser>;
    }
  }
}